import gql from "graphql-tag";

export default gql`
  mutation DestroyPostReply($replyId: ObjectID!) {
    destroyPostReply(replyId: $replyId)
  }
`;
